module.exports = __webpack_public_path__ + "static/floating-action-button-action-secondary-do-0753669edf6bf0c170548e7ca466fce1.png";